import { BoostCoverBulletPoints } from '@packages/types';

import { Icon } from '@elements/icon';
import { TextWithMd } from '@elements/text/textWithMd';
import { sluggify, testProps } from '@utils';

interface Props {
  isCovered?: boolean;
  item: BoostCoverBulletPoints;
}

export const BulletPointsItem = ({ item, isCovered }: Props) => {
  return (
    <div>
      <ul>
        {item.value.map(value => (
          <li key={value} className="flex py-1.5">
            <Icon
              name={isCovered ? 'check_circle' : 'cancel'}
              className={isCovered ? 'text-icon-success' : 'text-icon-warning'}
            />

            <TextWithMd
              className="ml-3 [&>ul]:list-disc [&>ul]:ml-6"
              {...testProps(sluggify(value))}>
              {value}
            </TextWithMd>
          </li>
        ))}
      </ul>
    </div>
  );
};
